var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9852C40.8218 0 47.9852 7.16344 47.9852 16V31.9852C47.9852 40.8218 40.8218 47.9852 31.9852 47.9852H16C7.16344 47.9852 0 40.8218 0 31.9852V16Z",
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8015_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3222 25.1588C33.3222 30.9897 29.2406 33.9052 24.3892 35.5962C24.1352 35.6823 23.8592 35.6781 23.6079 35.5845C18.7449 33.9052 14.6632 30.9897 14.6632 25.1588V16.9955C14.6632 16.6862 14.7861 16.3896 15.0048 16.1709C15.2235 15.9522 15.5201 15.8293 15.8294 15.8293C18.1618 15.8293 21.0772 14.4299 23.1064 12.6573C23.3535 12.4462 23.6678 12.3302 23.9927 12.3302C24.3177 12.3302 24.632 12.4462 24.879 12.6573C26.9198 14.4415 29.8237 15.8293 32.156 15.8293C32.4653 15.8293 32.762 15.9522 32.9807 16.1709C33.1994 16.3896 33.3222 16.6862 33.3222 16.9955V25.1588Z",
    stroke: "white",
    strokeWidth: 2.91547,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8015_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9885,
    height: 27.9885,
    fill: "white",
    transform: "translate(9.99841 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield2);
export default __webpack_public_path__ + "static/media/shield2.9f302f45e8a278d5a0452dd787849262.svg";
export { ForwardRef as ReactComponent };